"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyService = void 0;
const fp_1 = require("@ihr-radioedit/fp");
const util_1 = require("./util");
class KeyService {
    constructor(prefix = [], 
    /**
     * Whether to add segments of keys incrementally, e.g.
     * ```
     * false = ["prefix:addArg1:addArg2:addArg3"]
     *  true = ["prefix:addArg1", "prefix:addArg1:addArg2", "prefix:addArg1:addArg2:addArg3"]
     * ```
     */
    addGroupKeys = false) {
        this.prefix = prefix;
        this.addGroupKeys = addGroupKeys;
        this.priorityKeys = new Map();
    }
    get keys() {
        const flattened = Array.from(Array.from(this.priorityKeys.entries())
            .sort(([b], [a]) => a - b)
            .reduce((acc, [, priorityKeys]) => {
            priorityKeys.sort().forEach(k => acc.add(k));
            return acc;
        }, new Set()));
        return util_1.unique(flattened);
    }
    add(segments, opts) {
        var _a, _b, _c;
        const priority = (_a = opts === null || opts === void 0 ? void 0 : opts.priority) !== null && _a !== void 0 ? _a : 1;
        if ((_b = opts === null || opts === void 0 ? void 0 : opts.group) !== null && _b !== void 0 ? _b : this.addGroupKeys) {
            segments.forEach((_, i) => {
                var _a;
                const key = this.keyFrom(segments.slice(0, segments.length - i), opts === null || opts === void 0 ? void 0 : opts.excludePrefix);
                if (key) {
                    const collection = (_a = this.priorityKeys.get(priority + i)) !== null && _a !== void 0 ? _a : [];
                    collection.push(key);
                    this.priorityKeys.set(priority + i, collection);
                }
            });
        }
        else {
            const key = this.keyFrom(segments, opts === null || opts === void 0 ? void 0 : opts.excludePrefix);
            if (key) {
                const collection = (_c = this.priorityKeys.get(priority)) !== null && _c !== void 0 ? _c : [];
                collection.push(key);
                this.priorityKeys.set(priority, collection);
            }
        }
        return this;
    }
    all(segments, opts) {
        segments.forEach(segment => this.add(segment, opts));
        return this;
    }
    addTask(lambda) {
        return (task) => fp_1.pipe(task, fp_1.effect(i => this.add(lambda(i))));
    }
    allTask(lambda) {
        return (task) => fp_1.pipe(task, fp_1.effect(fp_1.AR.map(i => this.add(lambda(i)))));
    }
    keyFrom(segments, excludePrefix = false) {
        if (excludePrefix) {
            return segments
                .filter(util_1.notNullish)
                .join(":")
                .replace(/[^\x00-\x7F]/g, "");
            // The last line is to remove non-ASCII characters, @see IHRAR-7407
        }
        return [...this.prefix, ...segments]
            .filter(util_1.notNullish)
            .join(":")
            .replace(/[^\x00-\x7F]/g, "");
    }
    extend(...others) {
        others.map(other => {
            Array.from(other.priorityKeys.entries()).forEach(([priority, keys]) => {
                this.all(keys.map(fp_1.AR.of), { priority, excludePrefix: true, group: false });
            });
        });
    }
}
exports.KeyService = KeyService;
//# sourceMappingURL=skeys.js.map